import React from "react";

import { QuoteHeaderRow } from "./QuoteHeaderRow";
import { QuoteBody } from "./QuoteBody";
import { headerItemsList } from "../constants";

export const QuoteTable = ({ data, hasAnnualRate }) => {
  return (
    <div className="quote-table">
      <QuoteHeaderRow items={headerItemsList} hasAnnualRate={hasAnnualRate} />
      <QuoteBody items={data} hasAnnualRate={hasAnnualRate} />
    </div>
  );
};
